const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY as string

let loading: Promise<void> | null = null

function load(): Promise<void> {
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
      script.async = true
      script.onload = () => window.grecaptcha.ready(() => resolve())
      script.onerror = () => {
        loading = null
        reject(new Error('reCAPTCHA failed to load'))
      }
      document.head.appendChild(script)
    })
  }
  return loading
}

// reCAPTCHA v3 token for the backend to verify. Loaded lazily so pages that
// never register don't pull the script.
export async function getRecaptchaToken(action: string): Promise<string> {
  await load()
  return window.grecaptcha.execute(siteKey, { action })
}
